import { useState } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { parseDoubleEncodedJson } from '../../utils/apiHelpers';

interface AddContactPayload {
    entity_id: string;
    NAME?: string;
    LASTNAME?: string;
    FIRSTNAME?: string;
    JOB?: string;
    CIVILITY?: string;
    EMAIL?: string;
    PHONE?: string;
    DIALING_CODE?: string;
    TRAP_LEVEL?: string;
}

interface AddContactResponse {
    success?: boolean;
    CONTACT_ID?: string | number;
    id?: string | number;
    message?: string;
    [key: string]: any;
}

const useAddContact = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const addContact = async (payload: AddContactPayload): Promise<AddContactResponse | null> => {
        if (!isReady || !workspaceId) {
            setError('Workspace not ready');
            return null;
        }

        setIsLoading(true);
        setError('');
        try {
            const result = await authFetch('/addEntContact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            return parseDoubleEncodedJson(result) || { success: true };
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : 'Unknown error while creating the contact.';
            console.error('[useAddContact] failed:', { workspaceId, payload, message });
            setError(message);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { addContact, isLoading, error };
};

export default useAddContact;
